import React, { useMemo } from 'react';
import './check-in-info-view.scss';
import { getCustomerInfo, useAppSelector } from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';
import { useCurrentLocation } from '../../hooks';
import moment from 'moment';
import { CommonButton, ListSkeleton } from '../../components';
import { useNetworkContext } from '../../network';

interface CheckInInfoViewProps {
  onCheckInPress: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const CheckInInfoView: React.FC<CheckInInfoViewProps> = ({
  onCheckInPress,
  isLoading = false,
  disabled = false,
}) => {
  const { networkStatus: isOnline } = useNetworkContext();
  const { currentLocation, loading } = useCurrentLocation({
    isOnline,
  });
  const customerInfo = useAppSelector(getCustomerInfo);

  const checkInInfo = useMemo(
    () => [
      {
        key: 0,
        icon: SVGS.ZotokLoc,
        heading: 'Buyer Location',
        lines: [
          customerInfo?.customerAddress
            ? Object.values(customerInfo.customerAddress)?.join(', ')
            : '-',
        ],
      },
      {
        key: 1,
        icon: SVGS.GpsLocation,
        heading: 'Your Location',
        lines: [
          currentLocation?.formatted_address || '-',
          `Lat & Lon: ${currentLocation?.lat || '-'} & ${currentLocation?.lng || '-'}`,
        ],
      },
      {
        key: 2,
        icon: SVGS.CalendarSchedule,
        heading: 'Date & Time',
        lines: [moment().format('dddd, DD MMM YYYY - hh : mm : ss A')],
      },
    ],
    [customerInfo, currentLocation]
  );

  return (
    <div className="checkin-modal__container">
      <div className="checkin-modal__info">
        {checkInInfo.map((item, index) => (
          <div
            key={`${item.key}-${index}`}
            className="checkin-modal__info-section"
          >
            <div className="checkin-modal__info-header">
              <img src={item.icon} className="checkin-modal__info-icon" />
              <span className="checkin-modal__info-heading font-semibold">
                {item.heading}
              </span>
            </div>

            <div className="checkin-modal__info-desc">
              {item.lines.map((line, lineIndex) => (
                <>
                  {loading ? (
                    <ListSkeleton
                      length={1}
                      height={30}
                      className="checkin-list-skeleton-view"
                    />
                  ) : (
                    <span
                      key={lineIndex}
                      className="checkin-modal__info-text font-regular"
                    >
                      {line}
                    </span>
                  )}
                </>
              ))}
            </div>
          </div>
        ))}
      </div>

      <CommonButton
        text={'Yes, Check-in'}
        onPress={onCheckInPress}
        buttonStyle="checkin-modal__confirm-btn"
        loading={isLoading}
        spinnerColor="white"
        disabled={disabled}
      />
    </div>
  );
};
